import { gql } from '__generated__';

export default gql(`
  mutation DeleteTicketNumberSequence($id: ID!) {
    deleteTicketNumberSequence(id: $id)
  }
`);
